import React, { useState, useEffect } from "react";
import echarts from "echarts";
import { connect } from "react-redux";
import moment from "moment";

// ui组件
import AMap from "./AMap";
import "./center.scss";
import MediaComponent from "../../stationManagement/techProcess/components/media";
import SubTitle from "../components/Title/subTitle";

// store
import { setScreenInfo } from "@store/actions/common";

// api
import API from "../api/screen";
import publicApi from "@api/public";

// 图片
import center_bottom_01 from "../assets/center_bottom_01.png";
import center_bottom_02 from "../assets/center_bottom_02.png";
import center_bottom_03 from "../assets/center_bottom_03.png";
import center_bottom_bg from "../assets/center_bottom_bg.png";
import close_icon from "../assets/close_icon_blue.png";

const Block = ({ icon, lable, value }) => {
  return (
    <div className="flex alignItemCenter">
      <img src={icon} style={{ width: 16, height: 16 }} />
      <div className="color65 font13 ml8">{lable}</div>
      <div className="font13 ml8">{value}</div>
    </div>
  );
};
const Block2 = ({ lable, value }) => {
  console.log(lable, value, "ph");
  return (
    <div className="flexColumn alignItemCenter">
      {value && (
        <>
          <div className="color65 font12">{lable}</div>
          <div className="font12 numberFont">{value}</div>
        </>
      )}
      <img src={center_bottom_bg} style={{ width: 53, height: 20 }} />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};
export default connect(mapStateToProps)(
  ({ dispatch, showCenter, screenInfo }) => {
    const [data, setData] = useState([
      "总览",
      "COD",
      "NH3-N",
      "TP",
      "TN",
      "PH",
      "设备告警",
    ]); // cod,t等等数据
    const [active, setActive] = useState(0); //cod,t等等active
    const [click, setClick] = useState(""); //cod,t等等 点击项
    const [isPoll, setIsPoll] = useState(true); //cod,t等等是否轮询

    // 视频
    const [styleMedia, setStyleMedia] = useState({
      // 视频弹窗，右侧视频宽度
      width: 328,
      height: 246,
      widthGrid: "100%",
    });
    const [websocket, setWebSocket] = useState(null);
    const [playerList, setPlayerList] = useState([]); //电站摄像头列表
    const [playerDoms, setPlayerDoms] = useState({});
    const [testWebSocket, setTestWebSocket] = useState({});

    useEffect(() => {
      let interval = "";
      if (isPoll) {
        interval = setTimeout(() => {
          if (active < data.length - 1) {
            setActive(active + 1);
          } else {
            setActive(0);
          }
        }, 2 * 60 * 1000);
      } else {
        interval && clearTimeout(interval);
      }
      return () => {
        clearTimeout(interval);
      };
    }, [active, isPoll]);

    /*-------------------------------------------视频----start----------------------------------------------------*/
    useEffect(() => {
      screenInfo.clickStationId && initWebSocket();
      // screenInfo.clickStationId && findCamerasByStationId();
    }, [screenInfo.clickStationId]);

    // useEffect(() => {
    //   getPlayerDom();
    //   return () => { };
    // }, [playerList]);
    useEffect(() => {
      return () => {
        closeWebSocket();
        disposePlayerDoms();
      };
    }, []);
    // 关闭websocket
    const closeWebSocket = () => {
      let playerWebSocket = testWebSocket.playerWebSocket;
      playerWebSocket && playerWebSocket.close();
    };
    // 初始化链接websocket
    const initWebSocket = () => {
      let url = window.globalConfig.WEBSCOKETURL;
      let ws = new WebSocket(url);
      ws.onopen = () => {
        //setInterval(() => {
        //ws.send(param)
        // }, 60 * 1000)
        setWebSocket(ws);
      };
    };
    // 视频在关闭以后，必须销毁,不然视频存在内存中，不会再次被初始化
    const disposePlayerDoms = () => {
      playerList.length &&
        playerList.map((item) => {
          let player = window.videojs(`my-player${item.cameraId}`);
          if (player) {
            player.dispose();
            playerDoms[`playerDom${item.cameraId}`] = null;
            setPlayerDoms(playerDoms);
          }
        });
    };
    /**
     * 获取摄像头列表
     * @param {*} {}
     * @returns
     */
    const findCamerasByStationId = () => {
      API.findCameraByStationId({ stationId: screenInfo.clickStationId }).then(
        (res) => {
          if (res.status == 0 && res.data) {
            const data = res.data && JSON.parse(res.data);
            let list = [];
            data.forEach((item) => {
              item.SXT &&
                item.SXT.map((mm) => {
                  let obj = {
                    cameraId: mm.CCD,
                    rtspUrl: mm.URL,
                    studioId: item.VGW,
                  };
                  list.push(obj);
                });
            });
            setPlayerList(() => {
              return [...list];
            });
          } else {
            setPlayerList([]);
          }
        }
      );
    };

    const getPlayerDom = () => {
      if (playerList.length > 0) {
        playerList.map((item) => {
          publicApi.play(item).then((res) => {
            if (res.status == 0) {
              let dom = document.getElementById(`my-player${item.cameraId}`);
              if (dom && websocket) {
                websocket.onmessage = (evt) => {
                  //绑定收到消息事件
                  let data = JSON.parse(evt.data);
                  if (data.status == 0) {
                    let { cameraId, hlsUrl, rtmpUrl } = data.data;
                    playerList.map((mm) => {
                      if (mm.cameraId == cameraId) {
                        let videoDom = playerDoms[`playerDom${cameraId}`]
                          ? playerDoms[`playerDom${cameraId}`]
                          : window.videojs(`my-player${cameraId}`);
                        if (videoDom && videoDom.player_) {
                          videoDom.src({
                            type: "application/x-mpegURL",
                            src: hlsUrl,
                          });
                          testWebSocket[`playerWebSocket`] = websocket;
                          setTestWebSocket(testWebSocket);
                          playerDoms[`playerDom${cameraId}`] = videoDom;
                          setPlayerDoms(playerDoms);
                        }
                      }
                    });
                  }
                };
              }
            }
          });
        });
      }
    };
    const closeMonitor = () => {
      setPlayerList([]);
      dispatch(setScreenInfo({ ...screenInfo, clickStationId: "" }));
    };
    /*-------------------------------------------视频---end-----------------------------------------------------*/

    const changeNature = (index) => {
      // setActive(index);
      if (index === click) {
        setIsPoll(true);
      } else {
        setClick(index);
        setIsPoll(false);
      }
    };

    const _active = isPoll ? active : click;

    return (
      <>
        <div
          className="center-wrap relative"
          key={"divcenter111"}
          style={{ paddingTop: 10 }}
        >
          <AMap active={_active} activeText={data[_active]} />
          <div className="bottom_bg flexBetween">
            <div className="bottom_bg_left flexBetween">
              <Block
                key={"block1"}
                icon={center_bottom_01}
                lable="在线"
                value={screenInfo?.stationStatistics?.inLine ?? 0}
              />
              <Block
                key={"block2"}
                icon={center_bottom_02}
                lable="离线"
                value={screenInfo?.stationStatistics?.offLine ?? 0}
              />
              <Block
                key={"block3"}
                icon={center_bottom_03}
                lable="巡检人员"
                value={0}
              />
            </div>
            <div className="color65">
              共{screenInfo?.stationList?.length}个厂站
            </div>
          </div>
          {/* {
          screenInfo.clickStationId &&
          <div className="right">
            <SubTitle title={screenInfo.stationName} style={{ marginBottom: 16 }}>
              <img src={close_icon} alt="" style={{ width: 16, height: 16 }} onClick={closeMonitor} className="cursor" />
            </SubTitle>
            <div>
              {playerList &&
                playerList.length > 0 &&
                playerList.map((item, index) => {
                  return (
                    <div className="mb12" key={'palyer' + index}>
                      <MediaComponent
                        styleMedia={styleMedia}
                        key={index}
                        mediaProps={item}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        } */}
          <div className="bg-top"></div>
          <div className="bg-right"></div>
          <div className="bg-bottom"></div>
          <div className="bg-left"></div>
          {/* <div className="top">
            {data &&
              data.map((item, index) => {
                return (
                  <div
                    key={"top" + index}
                    className={`pointer top_select top_select_${index} ${
                      (active == index && isPoll) || (click == index && !isPoll)
                        ? "top_select_checked"
                        : ""
                    }`}
                    onClick={() => changeNature(index)}
                  >
                    {item}
                  </div>
                );
              })}
          </div> */}
          <div className="bottom flexBetween">
            <Block2
              key={"block11"}
              lable="COD告警"
              value={screenInfo?.alarmAndStationOnLineNum?.codAlarmNum ?? 0}
            />
            <Block2
              key={"block12"}
              lable="NH3-N告警"
              value={screenInfo?.alarmAndStationOnLineNum?.nh3nAlarmNum ?? 0}
            />
            <Block2
              key={"block13"}
              lable="TP告警"
              value={screenInfo?.alarmAndStationOnLineNum?.tpAlarmNum ?? 0}
            />
            <Block2
              key={"block14"}
              lable="TN告警"
              value={screenInfo?.alarmAndStationOnLineNum?.tnAlarmNum ?? 0}
            />
            <Block2
              key={"block15"}
              lable="PH告警"
              value={screenInfo?.alarmAndStationOnLineNum?.phAlarmNum ?? 0}
            />
            <Block2
              key={"block16"}
              lable="设备告警"
              value={screenInfo?.alarmAndStationOnLineNum?.deviceAlarmNum ?? 0}
            />
          </div>
        </div>
      </>
    );
  }
);
